import alt from '../alt'
import BookingActions from '../actions/BookingActions'

class BookingStore {
  constructor () {
    this.bindActions(BookingActions)

    this.bookings = []
  }

  onFetchedBookings (bookings) {
    this.bookings = bookings
  }
}

module.exports = alt.createStore(BookingStore, 'BookingStore')



// WEBPACK FOOTER //
// ./src/stores/BookingStore.js